module.exports = __webpack_public_path__ + "img/doc_connectas.c045b2e0.gif";